import numberOne from "../../../images/icon/numberOne.svg";
import numberTwo from "../../../images/icon/numberTwo.svg";
import tick from "../../../images/icon/tick-square.svg";

export const PatientTargetAdvantages = () => {
  return (
    <section className="section-sp2">
      <div className="container inner-content">
        <h2 className="text-center mb-4">
          Why You Can Trust This Type of Patient <br /> Outreach vs. Social
          Media Targeting
        </h2>
        <div className="solution-cards">
          <div
            className="problem-card"
            style={{
              background: "#F4F9FF",
              maxWidth: "630px",
              minHeight: "520px",
              padding: "30px",
              border: "1px solid #A4C6EC",
              boxShadow:
                "0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A",
            }}
          >
            <img src={numberOne} alt="" />
            <h3 style={{ color: "#0C71C3", marginBlock: "10px" }}>
              Built for Healthcare. Backed by HIPAA.
            </h3>
            <p>
              Social media relies on broad interest categories or behaviors that
              may or may not reflect a person’s true condition. In contrast:
            </p>
            <p style={{ display: "flex", gap: "5px", alignItems: "start" }}>
              <img src={tick} alt="" />
              <p>
                All patient data is{" "}
                <span style={{ fontWeight: "bold" }}>
                  de-identified, tokenized,
                </span>{" "}
                and handled in a way that is{" "}
                <span style={{ fontWeight: "bold" }}>100% HIPAA-compliant</span>
              </p>
            </p>
            <p style={{ display: "flex", gap: "5px", alignItems: "start" }}>
              <img src={tick} alt="" />
              No sensitive data is ever exposed or sold
            </p>
            <p style={{ display: "flex", gap: "5px", alignItems: "start" }}>
              <img src={tick} alt="" />
              <p>
                Every outreach begins with{" "}
                <span style={{ fontWeight: "bold" }}>intent + consent,</span>{" "}
                not inference or lookalikes.
              </p>
            </p>
          </div>
          <div
            className="solution-card"
            style={{
              background: "#F4F9FF",
              boxShadow:
                "0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A",
              border: "1px solid #A4C6EC",
              maxWidth: "630px",
              minHeight: "520px",
              padding: "30px",
            }}
          >
            <img src={numberTwo} alt="" />
            <h3 style={{ color: "#0C71C3", marginBlock: "10px" }}>
              Precise Targeting by Verified Medical Criteria
            </h3>
            <p>
              Social media relies on broad interest categories or behaviors that
              may or may not reflect a person’s true condition. In contrast:
            </p>
            <div style={{ display: "flex", gap: "5px", alignItems: "start" }}>
              <img src={tick} alt="" />
              <p>
                This approach uses{" "}
                <span style={{ fontWeight: "bold" }}>
                  verified claims data, self-reported opt-in responses,
                </span>{" "}
                and{" "}
                <span style={{ fontWeight: "bold" }}>
                  health-related site behavior
                </span>
              </p>
            </div>
            <div style={{ display: "flex", gap: "5px", alignItems: "start" }}>
              <img src={tick} alt="" />
              <p>
                Patients are identified based on{" "}
                <span style={{ fontWeight: "bold" }}>
                  actual diagnosis codes (e.g., ICD-10)
                </span>{" "}
                or specific survey participation
              </p>
            </div>
            <div style={{ display: "flex", gap: "5px", alignItems: "start" }}>
              <img src={tick} alt="" />
              You’re reaching people with{" "}
              <span style={{ fontWeight: "bold" }}>
                relevance, not assumptions
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
